import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { FC } from 'react';
import Countdown from 'react-countdown';
import { FormattedMessage } from 'react-intl';

interface IRendererProps {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  completed?: boolean;
}

const renderer = ({ days, hours, minutes, seconds, completed }: IRendererProps) => {
  if (completed) {
    return null;
  } else {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" gap={1} marginTop={5}>
        <Box bgcolor="warning.main" color="black" width="5em" paddingY={1} borderRadius="0.4em">
          <Typography fontSize="1.8em" fontWeight={700}>
            {days}
          </Typography>
          <Typography fontWeight={700} fontSize="0.8em">
            <FormattedMessage id="DAYS"/>
          </Typography>
        </Box>

        <Typography fontSize="1.8em" fontWeight={700}>
          {':'}
        </Typography>

        <Box bgcolor="warning.main" color="black" width="5em" paddingY={1} borderRadius="0.4em">
          <Typography fontSize="1.8em" fontWeight={700}>
            {hours}
          </Typography>
          <Typography fontWeight={700} fontSize="0.8em">
            <FormattedMessage id="HOURS"/>
          </Typography>
        </Box>

        <Typography fontSize="1.8em" fontWeight={700}>
          {':'}
        </Typography>

        <Box bgcolor="warning.main" color="black" width="5em" paddingY={1} borderRadius="0.4em">
          <Typography fontSize="1.8em" fontWeight={700}>
            {minutes}
          </Typography>
          <Typography fontWeight={700} fontSize="0.8em">
            <FormattedMessage id="MINUTES"/>
          </Typography>
        </Box>

        <Typography fontSize="1.8em" fontWeight={700}>
          {':'}
        </Typography>

        <Box bgcolor="warning.main" color="black" width="5em" paddingY={1} borderRadius="0.4em">
          <Typography fontSize="1.8em" fontWeight={700}>
            {seconds}
          </Typography>
          <Typography fontWeight={700} fontSize="0.8em">
            <FormattedMessage id="SECONDS"/>
          </Typography>
        </Box>
      </Box>
    );
  }
};

interface IExactScoreCountDownProps {
  date: Date | number;
}

const SuperExactScoreCountDown: FC<IExactScoreCountDownProps> = ({ date }) => {
  return <Countdown date={date} renderer={renderer}/>;
};

export default SuperExactScoreCountDown;